import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContentSection from '../components/ContentSection';
import { releases, siteReleases, currentVersion } from '../data/release-notes';
import '../styles/App.css';
import '../styles/Content.css';

function ReleaseNotes() {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr + 'T00:00:00');
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  const formatList = (items) => (
    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
      {items.map((item, index) => (
        <li key={index} style={{ padding: '8px 0', paddingLeft: '20px', position: 'relative' }}>
          <span style={{ position: 'absolute', left: 0 }}>•</span>
          {item}
        </li>
      ))}
    </ul>
  );

  // Merge site and app releases, sort newest first
  const allReleases = [
    ...siteReleases.map((r) => ({
      ...r,
      label: r.title,
      sortDate: r.releaseDate,
    })),
    ...releases.map((r) => ({
      ...r,
      label: `App ${r.version}`,
      sortDate: r.releaseDate,
    })),
  ].sort((a, b) => b.sortDate.localeCompare(a.sortDate));

  return (
    <div className="home">
      <SEO
        title="Release Notes"
        description={`What's new in Begin Strength ${currentVersion}. See the latest features, bug fixes, and improvements.`}
        image="/social-media-image.png"
        path="/release-notes"
      />
      <Header />
      <main>
        {allReleases.map((release, idx) => {
          const { newFeatures, bugFixes, optimizations, sortDate, label } = release;

          const allItems = [
            ...(newFeatures || []).map((category) => ({
              title: category.category,
              body1: formatList(category.items),
            })),
            ...(bugFixes && bugFixes.length > 0
              ? [{ title: 'Bug Fixes', body1: formatList(bugFixes) }]
              : []),
            ...(optimizations && optimizations.length > 0
              ? [{ title: 'Optimizations', body1: formatList(optimizations) }]
              : []),
          ];

          return (
            <ContentSection
              key={`${label}-${sortDate}`}
              sectionTitle={
                idx === 0 ? (
                  <>
                    Release <span style={{ color: 'red' }}>Notes</span>
                  </>
                ) : (
                  <>
                    {label.split(' ')[0]}{' '}
                    <span style={{ color: 'red' }}>{label.split(' ').slice(1).join(' ')}</span>
                  </>
                )
              }
              sectionDescription={
                idx === 0
                  ? `${label} — ${formatDate(sortDate)}`
                  : formatDate(sortDate)
              }
              items={allItems}
              showNumbers={false}
              titleTag={idx === 0 ? 'h2' : 'h3'}
              spacer={idx === 0}
            />
          );
        })}
      </main>
      <Footer />
    </div>
  );
}

export default ReleaseNotes;
